<template>
    <footer class="footer static footer-light">
        <p class="clearfix blue-grey lighten-2 mb-0"><span class="float-md-left d-block d-md-inline-block mt-25">COPYRIGHT &copy; 2026<a class="text-bold-800 grey darken-2" href="https://hilinksnetworks.ng" target="_blank">{{getConfig('footer_credit')}},</a>All rights Reserved</span><span class="float-md-right d-none d-md-block">Version 2.1</span>
            <button class="btn btn-primary btn-icon scroll-top" type="button"><i class="feather icon-arrow-up"></i></button>
        </p>
    </footer>
	
</template>

<script>
    export default { 
    	methods: {
    		getConfig(config){
    			return helper.getConfig(config);
    		}
    	}
    }
</script>